import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-roads.light.webp";
import imageDark from "../images/national-roads.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-roads",
  displayName: `National Roads`,
  datasetProductCode: `GEOSCAPE ROADS`,
  subtitle: `Comprehensive Digital Road Network Mapping`,
  shortDescription: `Roads is a digital representation of the road network of Australia. Roads contains linear features to describe surfaces that have been improved to enable vehicular, pedestrian and bicycle transportation on land and ferry routes that enable vehicles to cross water bodies. Roads does not include railways, tramways, driveways or passenger ferry routes.`,
  metadata: {
    dateAdded: 1585612800000,
    dataType: ["Lines"],
    theme: `Transport`,
    totalFeatureCount: 4226585,
    updateFrequency: `Monthly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/road.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/road.html`,
  imageLight,
  imageDark,
  searchTags: `National Roads Geoscape Roads Connectivity Infrastructure Logistics Movement Navigation Road Infrastructure Road Network Roads Route Planning Traffic Analysis Transportation`,
  detail: () => import("../details/national-roads").then((m) => m.detail),
};

export default entry;
